module.exports = __webpack_public_path__ + "static/media/background_login.921bc690.png";